import React, { useMemo } from 'react';
import MedicalReportDetailDefaultForm from './MedicalReportDetailDefaultForm';
import useTranslation from '../../Hooks/useTranslation';
import { firstUpperString } from '../FirstUpper';
import { FormValues } from '../../Modules/MagicForm/Interfaces/FormValues';
import useElectronicSignature from '../../Modules/Certificates/Hooks/useElectronicSignature';

interface MedicalReportDetailDefaultProps {
	patientId: string;
	workplaceId: string;
	loggedUserId: string;
	onSuccess?: (values: FormValues) => void;
	defaultData?: any;
	customSuccess?: (values: FormValues) => void;
	isMeddiCase: boolean;
}

interface MedicalReportDefaults {
	title: string;
	contactSpecialist: boolean;
	text?: string;
	electronicSignature?: boolean;
	electronicSignatureTimestamp?: boolean;
}

const MedicalReportDetailDefault: React.FC<MedicalReportDetailDefaultProps> = ({
	patientId,
	defaultData,
	onSuccess,
	customSuccess,
	isMeddiCase,
}) => {
	const { t } = useTranslation();
	const {
		isQualifiedCertificateForElectronicSignatureUsed,
		isElectronicSignatureTimestampAllowed,
	} = useElectronicSignature();

	const defaultValues: MedicalReportDefaults = useMemo(() => {
		return {
			title: firstUpperString(t('base.shared.medicalReport') + ''),
			contactSpecialist: false,
			diagnoses: [{ diagnose: { label: undefined, value: undefined } }],
			electronicSignature: isQualifiedCertificateForElectronicSignatureUsed,
			electronicSignatureTimestamp:
				isQualifiedCertificateForElectronicSignatureUsed &&
				isElectronicSignatureTimestampAllowed,
			...defaultData,
		};
	}, [isQualifiedCertificateForElectronicSignatureUsed, defaultData]);

	return (
		<MedicalReportDetailDefaultForm
			onSubmit={customSuccess ? customSuccess : onSuccess}
			isMeddiCase={isMeddiCase}
			defaultData={defaultValues}
			patientId={patientId}
		/>
	);
};

export default MedicalReportDetailDefault;
